import '@fontsource-variable/manrope';
import '@fontsource-variable/urbanist';
import '@fontsource-variable/newsreader';
import '@fontsource-variable/newsreader/wght-italic.css';
import './styles/app.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { ApiError, setUnauthenticatedHandler } from '@nw/web-platform';
import { createAppRouter } from './router.js';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
});
const router = createAppRouter(queryClient);

// A lost session clears every private cache before returning to sign-in.
setUnauthenticatedHandler(() => {
  if (router.state.location.pathname === '/signin') return;
  queryClient.clear();
  void router.navigate({ to: '/signin', search: { returnTo: router.state.location.href } });
});

document.addEventListener('visibilitychange', () => {
  document.documentElement.dataset.hidden = String(document.hidden);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
